// extracted by mini-css-extract-plugin
export default {"photoCarousel":"PhotoCarousel_photoCarousel__pkL6b","title":"PhotoCarousel_title__RZnbN","weddingCarousel":"PhotoCarousel_weddingCarousel__1am+5"};